import { createApp } from 'vue'

import '@unocss/reset/tailwind.css'
import '@daysmart/daysmart-vue-components/dist/icons.css'
import './core/styles/main.scss'
import './core/styles/fonts.scss'
import 'virtual:uno.css'
import 'virtual:unocss-devtools'

import App from './App.vue'

// necessary for unocss to recognize css classes
import.meta.glob('../node_modules/@daysmart/daysmart-vue-components/dist/*.js', { eager: true })

const app = createApp(App)

const blockingModules = import.meta.glob('./core/modules/blocking/*.ts', { eager: true })
for (const blockingModule of Object.values(blockingModules))
  await blockingModule.install?.(app)

Object
  .values(import.meta.glob('./core/modules/*.ts', { eager: true }))
  .forEach(i => i.install?.(app))

app.mount('#app')
